// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pXEauqe5Pckvhs {
  box-sizing: border-box;
  width: 100vw;
  max-height: calc(95vh - 96px);
  margin: var(--ds-space-0, 0) auto;
  padding: var(--ds-space-300, 24px);
}
@media (max-width: 750px) {
  .pXEauqe5Pckvhs {
    width: auto;
    padding: var(--ds-space-300, 24px) var(--ds-space-300, 24px) var(--ds-space-100, 8px) var(--ds-space-300, 24px);
  }
}
.pXEauqe5Pckvhs.HYnbrT7YIvw4NZ {
  max-width: 800px;
  overflow: auto;
}
.pXEauqe5Pckvhs.y787UZQlHy53PD,
.pXEauqe5Pckvhs.RlQuV3XVHlmazN {
  max-width: 480px;
}
.pXEauqe5Pckvhs.MD60zGrctRZ8Tp {
  max-width: 600px;
}
.pXEauqe5Pckvhs.LxuWiwK3AqEphR {
  max-width: 1130px;
  overflow: auto;
}
.pXEauqe5Pckvhs.IbahS5PhYmVYDB {
  max-width: 692px;
}
`, ""]);
// Exports
export var modalWrapper = `pXEauqe5Pckvhs`;
var _1 = `HYnbrT7YIvw4NZ`;
export { _1 as "trial-ended-plan-selection" };
var _2 = `y787UZQlHy53PD`;
export { _2 as "payment-standard" };
var _3 = `RlQuV3XVHlmazN`;
export { _3 as "payment-premium" };
var _4 = `MD60zGrctRZ8Tp`;
export { _4 as "free-selection-information" };
var _5 = `LxuWiwK3AqEphR`;
export { _5 as "plan-comparison" };
var _6 = `IbahS5PhYmVYDB`;
export { _6 as "closed-boards" };
export default ___CSS_LOADER_EXPORT___;
